import { styled } from '@mui/material/styles';
import { Toolbar as MuiToolbar } from '@mui/material';

export const StyledToolbar = styled(MuiToolbar)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  backgroundColor: 'transparent',
  borderTop: `1px solid ${theme.palette.divider}`,
}));
